import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" aria-labelledby="faq-title" className="w-full bg-background-100/60">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <h2 id="faq-title" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              吃瓜常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于更新时间、信息核实、内容原则与投稿方式，这里集中回答。还有疑问可以直接发邮件给我们。
            </p>
            <div className="mt-5 rounded-lg border border-accent-200 bg-accent-50 p-4">
              <p className="flex items-center gap-2 text-sm font-medium text-accent-900">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-shield-check-line text-base" aria-hidden="true" />
                </span>
                理性围观提醒
              </p>
              <p className="mt-2 text-xs leading-relaxed text-accent-800">
                瓜料会反转，判断需谨慎。请勿对当事人进行人身攻击，也别轻信没有出处的截图。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={item.q}
                    className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50"
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors duration-200 hover:bg-background-100/70 md:px-5"
                      >
                        <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line text-sm" : "ri-add-line text-sm"} aria-hidden="true" />
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="border-t border-background-200/70 px-4 py-4 md:px-5">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}